import * as React from 'react';

import Empty from '../../react-common/Empty';
import OfferMessageDetail from './OfferMessageDetail';
import OfferMessageRecipients from './OfferMessageRecipients';

import { PropertyAnnouncementType } from './types';

interface OfferMessageDetailContainerProps {
  listingId: string;
  propertyAnnouncement: PropertyAnnouncementType;
}

interface OfferMessageDetailContainerState {
  activeNavTab: 'message' | 'recipients';
}

class OfferMessageDetailContainer extends React.Component<
  OfferMessageDetailContainerProps,
  OfferMessageDetailContainerState
> {
  constructor(props: OfferMessageDetailContainerProps) {
    super(props);

    this.state = {
      activeNavTab: 'message',
    };
  }

  render() {
    const { listingId, propertyAnnouncement } = this.props;
    const { activeNavTab } = this.state;

    if (!propertyAnnouncement) {
      return <Empty text={'No message is selected.'} />;
    }

    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <ul className="nav nav-tabs">
              <li
                onClick={() => this.setState({ activeNavTab: 'message' })}
                className={
                  activeNavTab === 'message'
                    ? 'active offer-message-navtab-active'
                    : ''
                }
              >
                <a>Message</a>
              </li>
              <li
                onClick={() => this.setState({ activeNavTab: 'recipients' })}
                className={
                  activeNavTab === 'recipients'
                    ? 'active offer-message-navtab-active'
                    : ''
                }
              >
                <a>Recipients</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {activeNavTab === 'message' ? (
              <OfferMessageDetail propertyAnnouncement={propertyAnnouncement} />
            ) : (
              <OfferMessageRecipients
                listingId={listingId}
                propertyAnnouncement={propertyAnnouncement}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default OfferMessageDetailContainer;
